<template>
  <div class="border-b-1">
    <ul class="flex flex-row text-blue-800">
      <li v-for="item in items" :key="item.id">
        <tab-header :section="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import TabHeader from '@/components/details-components/TabHeader'
import { useStore } from 'vuex'
import { computed } from 'vue'
export default {
  name: 'ResourceDetailsHeader',
  components: { TabHeader },
  setup() {
    const store = useStore()

    const items = computed(() => store.state.Details.availableSections)

    return { items }
  },
}
</script>

<style scoped>

</style>
